const copyWithTextarea = (text: string): boolean => {
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand('copy');
    document.body.removeChild(textarea);
    return copied;
  } catch {
    return false;
  }
};

/**
 * navigator.clipboard solo existe en contextos seguros: servido por http en
 * una IP de la red interna no está, así que hay fallback al textarea.
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  if (navigator.clipboard?.writeText) {
    const copied = await navigator.clipboard.writeText(text).then(
      () => true,
      () => false
    );
    if (copied) return true;
  }
  return copyWithTextarea(text);
};
